module.exports = __webpack_public_path__ + "front/img/33_4.c291af9c.png";